module.exports = __webpack_public_path__ + "static/media/right-arrow.966aa7e5.svg";